export enum SUBSCRIPTION_TYPE {
  FREE = 'FREE',
  BASIC = 'BASIC',
  STANDARD = 'STANDARD',
  ADVANCED = 'ADVANCED'
}

export enum SUBSCRIPTION_STATUS {
  ACTIVE = 'ACTIVE',
  CANCEL = 'CANCEL',
  EXPIRED = 'EXPIRED'
}

export interface Subscription{
    type: SUBSCRIPTION_TYPE;
    status: SUBSCRIPTION_STATUS;
    startDate: string;
    endDate: string;
    isPremium: boolean;
}

export interface SubscriptionResponse {
    success: boolean;
    statusCode: number;
    statusMessage: string;
    data: Subscription;
}